import { de_SendCancellationEMailCommand, se_SendCancellationEMailCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
export { $Command };
export class SendCancellationEMailCommand extends $Command.classBuilder()
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
    ];
})
    .s("Api", "SendCancellationEMail", {})
    .n("ApiClient", "SendCancellationEMailCommand")
    .f(void 0, void 0)
    .ser(se_SendCancellationEMailCommand)
    .de(de_SendCancellationEMailCommand)
    .build() {
}
